import {Cloud}  from 'react-feather'
const localConfigs = {
  app: {
  	appName: 'AKH Portal',
    appLogoImage: require('@csrc/assets/images/logo/logo.png').default,
    images:{
      login:  require(`@csrc/assets/images/login.png`).default,
      loginDark:  require(`@csrc/assets/images/login.png`).default,
      register:  require(`@csrc/assets/images/login.png`).default,
      registerDark:  require(`@csrc/assets/images/login.png`).default,
      forgetPassword:  require(`@csrc/assets/images/forgot-password.svg`).default,
      forgetPasswordDark:  require(`@csrc/assets/images/forgot-password-dark.svg`).default
    },
    footerUrl:'#'
  },
  layout: {
    isRTL: false,
    skin: 'semi-dark', // light, dark, bordered, semi-dark
    skinOptions: {
      "semi-dark": {nextSkin: 'dark', icon: <Cloud className='ficon'/>}
    },
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true
    },
    navbar: {
      type: 'floating',
      backgroundColor: 'white'
    },
    footer: {
      type: 'sticky'
    },
    customizer: false,
    scrollTop: true
  },
  auth: {
    login: {
      welcome: 'Willkommen im Portal der AKH'
    },
    register: {
      welcome: '',
      terms: <span>Ich stimme den <a target="_blank" href="https://www.akh.de/datenschutz">Datenschutzbedingungen</a> zu</span>
    }
  }

	// app: {
	// 	appName: 'Fwork',
	// 	appLogoImage: require('@src/assets/images/logo/logo.png').default
	// },
	// layout: {
	// 	isRTL: false,
  // skin: 'semi-dark', // light, dark, bordered, semi-dark
  // skinOptions:{
  //   light:{nextSkin:'semi-dark', icon: <Sun className='ficon' />},
  //   "semi-dark":{nextSkin:'dark', icon: <Cloud className='ficon' />},
  //   dark:{nextSkin:'light', icon: <Moon className='ficon' />}
  // },
	// 	routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
	// 	type: 'vertical', // vertical, horizontal
	// 	contentWidth: 'full', // full, boxed
	// 	menu: {
	// 		isHidden: true,
	// 		isCollapsed: true
	// 	},
	// 	navbar: {
	// 		// ? For horizontal menu, navbar type will work for navMenu type
	// 		type: 'floating', // static , sticky , floating, hidden
	// 		backgroundColor: 'white' // BS color options [primary, success, etc]
	// 	},
	// 	footer: {
	// 		type: 'sticky' // static, sticky, hidden
	// 	},
	// 	customizer: false,
	// 	scrollTop: true // Enable scroll to top button
	// }
}
export default localConfigs
